import { TypedAction } from '@ngrx/store/src/models';
import { setContractTypeFilterBasedOnUrlValue } from './contract-type.actions';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class ContractTypeFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    return setContractTypeFilterBasedOnUrlValue({
      value: urlValue,
    });
  }

  serialize(state: AppState): string {
    const contractTypeOption = state.filter.contractType.filter;
    return `${contractTypeOption.value}`;
  }
}
